import {Hide} from 'platform/foundation';

import {RatingCard} from '../Rating/RatingCard';
import {ReservationCard} from '../ReservationCard/ReservationCard';
import {SellerCard} from '../SellerCard/SellerCard';
import {VehicleIsYoursCard} from './VehicleIsYoursCard';

export function AfterSaleSidebar() {
  return (
    <>
      <VehicleIsYoursCard />
      <RatingCard />
      <ReservationCard />
      <Hide onMobile onTablet>
        <SellerCard />
      </Hide>
    </>
  );
}
